import {
  ElNotification,
} from "element-plus";

export default defineNuxtPlugin((nuxtApp) => {
  const isChunkError = (error: any): boolean => {
    if (!error) {
      return false;
    }
    const message = error.message || String(error);
    return (
      message.includes("Failed to fetch dynamically imported module")
      || message.includes("TypeError: Failed to fetch dynamically imported module")
      || message.toLowerCase().includes("loading chunk")
      || message.toLowerCase().includes("failed to fetch dynamically")
    );
  };

  const handleChunkError = (error: any) => {
    if (!isChunkError(error)) {
      return;
    }

    try {
      const {error: logError} = useFrontendLogger();
      logError(`Chunk load error: ${error.message || String(error)}`, "chunk-error-handler", {
        stack: error.stack,
      });
    } catch (err) {
      console.warn(err);
    }

    const now = Date.now();
    const lastReload = sessionStorage.getItem("chunk-error-reload-time");
    if (lastReload) {
      const timeDiff = now - parseInt(lastReload, 10);
      if (timeDiff < 10000) {
        ElNotification({
          title: "Application Updated",
          message: "A new version of the app is available. Please reload the page to get the latest features.",
          type: "error",
          duration: 0,
        });
        return;
      }
    }

    sessionStorage.setItem("chunk-error-reload-time", String(now));
    window.location.reload();
  };

  nuxtApp.hook("app:chunkError", ({error}) => {
    handleChunkError(error);
  });

  window.addEventListener("error", (event) => {
    handleChunkError(event.error || event.message);
  });

  window.addEventListener("unhandledrejection", (event) => {
    handleChunkError(event.reason);
  });
});
